<!--  -->
<template>
    <div>
        <div class="tel">
            服务热线：<a @click="service">{{ zzconfig.PHONE }}</a>
        </div>
    </div>
</template>

<script>
import { zzconfig } from "@/config/zzconfig";
export default {
    name: "Telephonne",
    data() {
        return {
            zzconfig,
        };
    },

    methods: {
        //客服热线
        service() {
            window.location.href = `tel:${zzconfig.PHONE}`;
        },
    },
};
</script>
<style lang="less" scoped>
.tel {
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 28px;
}
</style>
